// TermsPage.jsx
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 64rem;
  margin: 0 auto;
  padding: 1.5rem;
  padding-bottom: 4rem;
  color: #f3f4f6;
`;

const Title = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #ffffff;
`;

const Subtitle = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
  margin-bottom: 1.5rem;
`;

const Section = styled.section`
  margin-bottom: 1rem;
`;

const Heading2 = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #ffffff;
`;

const Paragraph = styled.p`
  line-height: 1.6;
`;

export default function TermsPage() {
    return (
        <Container>
            <Title>Terms &amp; Conditions</Title>
            <Subtitle>Effective Date: July 1, 2025</Subtitle>

            <Section>
                <Heading2>1. Services &amp; Deliverables</Heading2>
                <Paragraph>
                    Zumosoft provides strategic IT consultations and implementation services ("Services")
                    as described in each booking confirmation.
                </Paragraph>
            </Section>

            <Section>
                <Heading2>2. Booking &amp; Payment</Heading2>
                <Paragraph>
                    A non-refundable engagement fee (as stated on the booking page) is required to reserve
                    paid sessions. For cancellations or rescheduling, please provide at least 48 hours&#8217; notice.
                    Late cancellations will forfeit the engagement fee.
                </Paragraph>
            </Section>

            <Section>
                <Heading2>3. Scope &amp; Limitations</Heading2>
                <Paragraph>
                    Consultations include live meeting time plus any agreed write-ups or follow-up. Any
                    coding or extended implementation beyond the booked session is billed separately at the
                    stated hourly rate.
                </Paragraph>
            </Section>

            <Section>
                <Heading2>4. Confidentiality</Heading2>
                <Paragraph>
                    All information you share is held in strict confidence. Zumosoft will not disclose your
                    proprietary data without your consent.
                </Paragraph>
            </Section>

            <Section>
                <Heading2>5. Liability Disclaimer</Heading2>
                <Paragraph>
                    Zumosoft makes no guarantees about specific outcomes. Our advice is provided &ldquo;as-is&rdquo;
                    and you assume all risk for implementing recommendations.
                </Paragraph>
            </Section>

            <Section>
                <Heading2>6. Governing Law</Heading2>
                <Paragraph>
                    These terms are governed by the laws of the State of Michigan, USA.
                </Paragraph>
            </Section>
        </Container>
    );
}